import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ITextCol } from '../table.type';
import { ColBase } from './col.base';

@Component({
  selector: 'bixi-table-col-text',
  host: { '[class.bixi-table-col-text]': 'true' },
  template: `
    <div [ngStyle]="outerStyle">
      <span nz-tooltip [nzTooltipTitle]="tooltip" [ngStyle]="innerStyle">{{ value }}</span>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BixiTableColTextComponent extends ColBase {
  @Input() col: ITextCol;
}
